import styled from '@emotion/styled';

export const TextContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.8rem',
}));

export default TextContainer;
